export default __webpack_public_path__ + "static/media/7.c8fb779b.jpg";